// extracted by mini-css-extract-plugin
export default {"top-control":"NoteSender_top-control__vx3SI","note-review-top":"NoteSender_note-review-top__zMENn"};